export interface AccountColors {
  background?: string | null;
  body?: string | null;
  border?: string | null;
  neutral?: string | null;
  neutralLighten?: string | null;
  primary?: string | null;
  primaryText?: string | null;
  secondary?: string | null;
  tertiary?: string | null;
  text?: string | null;
}

export interface StudentTheme {
  background: string;
  body: string;
  border: string;
  neutral: string;
  primary: string;
  primaryText: string;
  secondary: string;
  text: string;
}

// Conta recem-criada ainda nao tem tema; sem fallback o app renderiza preto no
// preto. Os valores espelham o DefaultTheme do app mobile.
const FALLBACK: StudentTheme = {
  background: '#111111',
  body: '#1c1c1e',
  border: '#2c2c2e',
  neutral: '#8e8e93',
  primary: '#c6f432',
  primaryText: '#111111',
  secondary: '#5ac8fa',
  text: '#ffffff',
};

const pick = (valor: string | null | undefined, padrao: string): string => {
  const limpo = valor?.trim();

  return limpo ? limpo : padrao;
};

export const buildTheme = (colors?: AccountColors | null): StudentTheme => ({
  background: pick(colors?.background, FALLBACK.background),
  body: pick(colors?.body, FALLBACK.body),
  border: pick(colors?.border, FALLBACK.border),
  neutral: pick(colors?.neutral, FALLBACK.neutral),
  primary: pick(colors?.primary, FALLBACK.primary),
  primaryText: pick(colors?.primaryText, FALLBACK.primaryText),
  secondary: pick(colors?.secondary, FALLBACK.secondary),
  text: pick(colors?.text, FALLBACK.text),
});
